import React from 'react';
import '../../assets/css/form.css'; // Ensure you have this CSS file
import { Link } from 'react-router-dom'; // Use react-router-dom for routing




const ContactMain = () => {
    const contactInfo = {
        phone: [
            { number: "+91 80969 62555", link: "tel:+91 80969 62555" },
            // { number: "(208) 555-0112", link: "tel:2085550112" }
        ],
        email: [
            { address: "info@techtotalers.in", link: "mailto:sarazbhuiyan0214@gmail.com" },
            // { address: "saiyam@gmail.com", link: "mailto:saiyam@gmail.com" }
        ],
        location: "2nd Floor, Hitech City Rd, Showbhagya Amulya Complex"
    };

    return (
        <React.Fragment>
            {/* Google Map Start */}
            
            <section className="google-map-one">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d60899.00421260315!2d78.382239!3d17.450725!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb938684d9c395%3A0x47021c763c0398e4!2sDomino&#39;s%20Pizza%20%7C%20Madhapur%2C%20Hyderabad!5e0!3m2!1sen!2sus!4v1739977391166!5m2!1sen!2sus"
                className="google-map__one"
                allowFullScreen
                title="Map showing location of Costco Wholesale"
            />
            </section>
            {/* Google Map End */}

            {/* Contact Page Start */}
   
            {/* Contact Page End */}
        </React.Fragment>
    );
};

export default ContactMain;
